export default __webpack_public_path__ + "static/assets/66c4abf4099e14375a635e94579546e6.gif";